import axios from "axios";
// import "pdfjs-dist/build/pdf.worker.min.mjs";

export async function fetchCopilotAccessToken(CopilotConfiguredPAUrl) {
  try {
    const response = await axios.post(
      CopilotConfiguredPAUrl,
      {
        QueryType: "GetToken",
      },
      {}
    );

    return response.data.token;
  } catch (error) {
    console.error("Error fetching token:", error);
    return null;
  }
}

export const getConversationID = async (accessToken) => {
  try {
    const response = await axios.post(
      `https://directline.botframework.com/v3/directline/conversations`,
      {},
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    return response.data.conversationId;
  } catch (error) {
    console.error("Error starting conversation:", error);
    return null;
  }
};

export const getConversationMessages = async (directLineToken, conversationId, watermark) => {
  try {
    const QueryURL = `https://directline.botframework.com/v3/directline/conversations/${conversationId}/activities${
      watermark ? `?watermark=${watermark}` : ""
    }`;
    const response = await axios.get(QueryURL, {
      headers: { Authorization: `Bearer ${directLineToken}` },
    });

    return response.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};
